import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import FormViewButton from 'components/Common/Buttons/FormViewButton';
import FormWorkflowStages from 'common/Workflows/FormWorkflowStages';

class AccountFormList extends PureComponent {
  static propTypes = {
    onConfirmFormUnlink: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    account: PropTypes.shape(),
    onDeleteForm: PropTypes.func.isRequired
  };

  static defaultProps = {
    permissions: null,
    account: {
      forms: []
    }
  };

  render() {
    const { permissions, account, onConfirmFormUnlink, onDeleteForm } = this.props;
    return (
      <div>
        <div>
          <table className="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Form Type</th>
                <th>Date Uploaded</th>
                <th>Entity Name</th>
                <th width="300px">Expiration Date</th>
                <th>Signed Date</th>
                <th>Workflow</th>
                <th>Original Filename</th>
                <th>View/Action</th>
              </tr>
            </thead>
            <tbody>
              { (account != null && account.forms != null && account.forms.length > 0)
                && account.forms.sort((a, b) => {
                  if (moment(b.validUntil).isSame(a.validUntil)) {
                    return moment(b.dateUploaded).isAfter(a.dateUploaded) ? 1 : -1;
                  }
                  return moment(b.validUntil).isAfter(a.validUntil) ? 1 : -1;
                }).map(formData => formData != null && <tr key={ formData.id }>
                  <td align="center">{ formData.formTypeDescription != null ? formData.formTypeDescription : '' }</td>
                  <td align="center">{ formData.dateUploaded != null ? moment(formData.dateUploaded).format('MMM DD, YYYY') : '' }</td>
                  <td>{ formData.entityName }</td>
                  <td align="center">{(() => {
                    if (!formData.isValid) {
                      return 'N/A - Invalid Form';
                    }
                    if (formData.validUntil && formData.validUntil !== null) {
                      const expiryReason = formData.expiryReasonDescription !== null ? `(${ formData.expiryReasonDescription })` : '';
                      if (formData.validUntil.includes('9999')) {
                        return `Evergreen ${ expiryReason }`;
                      }
                      return `${ moment(formData.validUntil).format('MMM DD, YYYY') } ${ expiryReason }`;
                    }
                    return '';
                  })()}
                  </td>
                  <td align="center"> {formData.dateSigned !== null ? moment(formData.dateSigned).format('MMM DD, YYYY') : ''} </td>
                  <td align="center">{ formData.workflowStageDescription ?? 'N/A' }</td>
                  <td>{ formData.originalFileName }</td>
                  <td className="form-action-btn-group">
                    {
                      (
                        (formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.electronicView,
                              ActivityPerms.electronicValidate
                            ]
                          )
                        ) || (
                          !formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.scannedView,
                              ActivityPerms.scannedEdit,
                              ActivityPerms.scannedValidate
                            ]
                          )
                        )
                      ) && formData.formType && formData.formType.toLowerCase() !== 'unknown' && <FormViewButton
                        content={ <span className="icon icon-apps" /> }
                        className="btn btn-sm"
                        title="Reopen"
                        formId={ formData.id }
                        accountId={ formData.accountId }
                        form={ formData }
                        permissions={ permissions }
                      />
                    }
                    { formData.numAccountsLinked && formData.numAccountsLinked > 1 && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit])
                      && <button
                        className="btn btn-sm btn-danger"
                        onClick={ () => onConfirmFormUnlink(formData.id) }
                        type="button"
                        title="Unlink form"
                      >
                        <span className="icon icon-link" />
                      </button> }
                    {
                      (
                        ((
                          ((formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteCompleteForms]))
                          || (!formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteCompleteForms])))
                          && formData.workflowStage === FormWorkflowStages.Complete)
                        || (
                          ((formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteInReviewForms]))
                          || (!formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteInReviewForms])))
                          && formData.workflowStage !== FormWorkflowStages.Complete))
                        && formData.formType && formData.formType.toLowerCase() !== 'unknown'
                      )
                      && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && <button
                        className="btn btn-sm btn-danger"
                        type="button"
                        title="Delete form"
                        onClick={ () => onDeleteForm(formData) }
                      >
                        <span className="icon icon-delete" />
                      </button>
                    }
                  </td>
                </tr>) }
              { (!account || !account.forms || account.forms.length === 0)
                && <tr><td colSpan="8" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AccountFormList;
